/**
 * @description Примесь звонков.
 * @type {Vue}
 */
export default {
  data() {
    return {
      /**
       * @description Ожидание завершения запроса.
       * @type {boolean}
       */
      isAwaitCallRequest: false,
    };
  },
  methods: {
    /**
     * @description Заменить префикс номера телефона на стандартный.
     * @param {string} input Исходная строка.
     * @returns {string}
     */
    normalizePrefixPhoneNumber(input) {
      if (input.startsWith('8')) {
        return `+7${input.substring(1)}`;
      }
      if (input.startsWith('7')) {
        return `+${input}`;
      }
      return input;
    },
    /**
     * @description Обработать инициацию звонка с пациентом.
     * @param {number} patientId
     * @param {?string} phoneNumber
     * @returns {void}
     */
    onInitiateCallByPatient(patientId, phoneNumber = null) {
      if (this.isAwaitCallRequest) { return; }
      const onFail = (error) => {
        if (error.has('error')) {
          this.notifyFail(error.allCauses().error.join('. '));
        } else {
          this.notifyFail(error.getTitle());
        }
      };
      this.isAwaitCallRequest = true;
      this
        .$telephonyIntegrationGateway
        .initiateCallByPatient(patientId, phoneNumber)
        .then((result) => result.forEachLeft(onFail))
        .finally(() => { this.isAwaitCallRequest = false; });
    },
    /**
   * @description Обработать инициацию звонка по записи на прием.
   * @param {number} appointmentId
   * @returns {void}
   */
    onInitiateCallByAppointment(appointmentId) {
      if (this.isAwaitCallRequest) { return; }
      const onFail = (error) => {
        if (error.has('error')) {
          this.notifyFail(error.allCauses().error.join('. '));
        } else {
          this.notifyFail(error.getTitle());
        }
      };
      this.isAwaitCallRequest = true;
      this
        .$telephonyIntegrationGateway
        .initiateCallByAppointment(appointmentId)
        .then((result) => result.forEachLeft(onFail))
        .finally(() => { this.isAwaitCallRequest = false; });
    },
  },
};
